// extracted by mini-css-extract-plugin
export default {"introContainer":"Intro_introContainer__btjXL","intro":"Intro_intro__DmJuU","moveBackground":"Intro_moveBackground__2Pcn6"};